import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import * as Highcharts from 'highcharts';
import {groupBy} from 'lodash';

@Component({
    selector: 'app-event-dyn-chart',
  templateUrl: './event-dyn-chart.component.html',
  styleUrls: ['./event-dyn-chart.component.scss']
})
export class EventDynChartComponent implements OnInit, OnChanges {
  @Input() filters: any;
  @Input() measures: any[];

  @ViewChild('chartContainer', {static: true}) chart: any;

  private categoriesInSeconds = ['Duration'];

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filters) {
      this.updateChart(this.measuresFormatted());
    }
  }

  private measuresFormatted(): any {
    let zonesArray = this.setLimitsZones();
    // We group limits by occurrences and reduce precision, Ex : [0.13554, 0.135498] become [0.135, 2]
    let seriesGroup: any = groupBy(this.measures.map((m) => {
      const fixedNbr = m[this.filters.chartCategory].toFixed(3);
      return Math.abs(fixedNbr) === 0 ? '0.000' : fixedNbr; // In case of a -0.000 or 0.000 occurs, we must format to dont have overlap in series
    }).sort((a, b) => a - b));
    let seriesData = [];
    for (let key in seriesGroup) {
      seriesData.push([parseFloat(key), seriesGroup[key].length]);
    }
    return {seriesData, zonesArray};
  }

  private setLimitsZones(): any {
    let limits = [];
    if (!isNaN(this.filters.minCategoryLimit)) {
      limits.push({value: this.filters.minCategoryLimit}, {color: 'yellow'});
    }
    if (!isNaN(this.filters.mediumCategoryLimit)) {
      limits.push({value: this.filters.mediumCategoryLimit}, {color: 'orange'});
      let yellow = limits.find((l) => l.color === 'yellow');
      if (!!yellow) {
        yellow.value = this.filters.mediumCategoryLimit;
      }
    }
    if (!isNaN(this.filters.maxCategoryLimit)) {
      limits.push({value: this.filters.maxCategoryLimit}, {color: 'red'});
      let yellow = limits.find((l) => l.color === 'yellow');
      let orange = limits.find((l) => l.color === 'orange');
      if (!!orange) {
        orange.value = this.filters.maxCategoryLimit;
      } else if (!!yellow) {
        yellow.value = this.filters.maxCategoryLimit;
      }
    }
    return limits;
  }

  updateChart(values: { seriesData: any[], zonesArray: any[] }): void {
    if (this.chart.update) {
      this.chart.update({
        xAxis: {
          title: {text: this.getCategoryTitle()}
        },
        series: {
          id: 'main',
          data: values.seriesData,
          zoneAxis: 'x',
          zones: values.zonesArray
        }
      });
    } else {
      this.buildChart(values);
    }
  }

  getCategoryTitle() {
    return this.categoriesInSeconds.includes(this.filters.chartCategory) ? this.filters.chartCategory + ' (s)' : this.filters.chartCategory;
  }

  buildChart(data): void {
    // zoneAxis not supported by local ts.lib => type any to options
    let options: any = {
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
        zIndex: 0,
        style: {
          fontFamily: 'Times New Roman'
        }
      },
      tooltip: {
        hideDelay: 100,
        shadow: false,
        borderRadius: 0,
        backgroundColor: '#ffffff',
        borderColor: '#212121',
        animation: false,
        formatter: function (): any {
          return 'Value: ' + this.key + '<br>Occurence(s): ' + this.y;
        }
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        startOnTick: false,

        title: {
          text: this.getCategoryTitle()
        },
        labels: {
          rotation: -45,
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif'
          }
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Frequency'
        },
        labels: {
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif'
          }
        },
      },
      legend: {
        enabled: false
      },
      series: [{
        id: 'main',
        data: data ? data.seriesData : {},
        zoneAxis: 'x',
        color: '#a0bcd8',
        zones: data ? data.zonesArray : {}
      }],
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 1,
          groupPadding: 0,
          shadow: false
        }
      },
      credits: {
        enabled: false
      }
    };

    this.chart = Highcharts.chart(this.chart.nativeElement, options);
  }
}
